export const Unauthorized = () => {
  return (
    <>
      You are not allowed to access this page.
    </>
  )
}